import React from 'react';

interface EmailResultModalProps {
  show: boolean;
  onClose: () => void;
  emailResult: any;
}

const EmailResultModal: React.FC<EmailResultModalProps> = ({
  show,
  onClose,
  emailResult
}) => {
  if (!show || !emailResult) return null;

  return (
    <div className="modal show d-block" tabIndex={-1}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Email Sending Result</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p><strong>Status:</strong> <span>{emailResult.message}</span></p>
            <p><strong>Emails Skipped:</strong> <span>{emailResult.skippedCount || 0}</span></p>
            <p><strong>Emails Sent:</strong> <span>{emailResult.sentCount || 0}</span></p>
            <p><strong>Failed Emails:</strong> <span>{emailResult.errorCount || 0}</span></p>
            {emailResult.errorEmails && emailResult.errorEmails.length > 0 && (
              <>
                <p><strong>Failed Email Addresses:</strong></p>
                <ul>
                  {emailResult.errorEmails.map((email: string, index: number) => (
                    <li key={index}>{email}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailResultModal;
